import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Link } from '@fluentui/react';
import { Dialog } from '@eta/components';
import QRCode from 'qrcode.react';
import './SuccessRegister.scss';

export interface SuccessRegisterProps {
    hidden: boolean;
    rin?: string;
    primaryName?: string;
    secondaryName?: string;
    email?: string;
}

export const SuccessRegister: FC<SuccessRegisterProps> = (
    props: SuccessRegisterProps
) => {
    const { t } = useTranslation(['SignUp']);
    const { hidden, rin, primaryName, secondaryName, email } = props;
    return (
        <Dialog
            hidden={hidden}
            onDismiss={() => {;}}
            maxWidth={800}
            title=""
            containerClassName="successSelfRegistryTaxpayer"
        >
            <div className="successRegistryContent">
                <div className="center">
                    <div className="top_content">
                        <Icon
                            iconName="VerifiedBrandSolid"
                            className="ms-IconCheck"
                        />
                        <span>{t('RegistrationCompleted')}</span>
                    </div>
                    <div className="content">
                        <div className="description">
                            <p>
                                {`${t('SuccessfullyRegistered', {
                                    rin,
                                })}: ${primaryName}/${secondaryName}`}
                            </p>
                            <br />
                        </div>
                        <div className="warning">
                            <p>
                                {t('CompleteRegistery', {
                                    email: `*****${email?.substr(
                                        email?.lastIndexOf('@')
                                    ) || ''}`,
                                })}
                            </p>
                        </div>
                    </div>
                    <div className="container-userlinks">
                        <div className="content-useFullinks">
                            <p className="bold">{t('UsefulLinks')}</p>
                            <div className="linksContent">
                                <div>
                                    •{' '}
                                    <Link href="http://Eta.gov.eg">
                                        Eta.gov.eg
                                    </Link>
                                </div>
                                <div>
                                    •{' '}
                                    <Link href="https://www.incometax.gov.eg">
                                        Incometax.gov.eg
                                    </Link>
                                </div>
                                <div>
                                    •{' '}
                                    <Link href="http://Mof.gov.eg">
                                        Mof.gov.eg
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="content-qrCodes">
                            <p className="bold"> {t('MobileApplication')}</p>
                            <div className="inner-content">
                                <div>
                                    <QRCode
                                        id="androidQr"
                                        size={70}
                                        value="https://play.google.com/store/apps/details?id=eg.gov.eta.einvoicing"
                                        className="android-qr"
                                    />
                                    <p className="status">{t('Android')}</p>
                                </div>
                                <div>
                                    <QRCode
                                        id="iosQr"
                                        size={70}
                                        value="https://apps.apple.com/eg/app/egyptian-einvoicing/id1570029377"
                                        className="ios-qr"
                                    />
                                    <p className="status">{t('Ios')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="logoTop">
                <img src="/logo-Success1.png" alt="Application logo" />
            </div>
            <div className="logoBottom">
                <img src="/logo-Success2.png" alt="Application logo" />
            </div>
        </Dialog>
    );
};
